<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="title-pages">PENDÊNCIAS DE TODAS AS PRESCRIÇÕES</h1>
    </div>
    <div class="col-md-12">
      <b-overlay :show="loading" opacity="0.99">
        <div v-show="data.length === 0" class="v-clean p-5">
          <h6 class="text-center upper-text worksansr">
            NÃO EXISTE CHECAGENS PENDENTES!
          </h6>
        </div>
        <div v-show="data.length > 0">
          <v-data-table
            dense
            :headers="headers"
            :items="data"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.date`]="{ item }">
              <div class="d-flex align-items-center">
                <b class="mr-2">{{ formatDate(item.date, false) }}</b>
                <v-btn
                  small
                  @click="handleItem(item.date)"
                  class="mt-1 mb-1 v-primary"
                >
                  <i class="fas fa-arrow-right mr-2"></i>
                  ACESSAR
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>
      </b-overlay>
      <ErrorsMessages :errors="errors" />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import api from "../../../services/api";

import routes from "../../../routes";

import { formatDate } from "../../../lib/format";

export default {
  name: "Check",

  components: {
    ErrorsMessages,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      headers: [{ text: "DATA", value: "date", sortable: false }],

      resident_id: "",

      data: [],

      errors: [],

      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.verify();
    },

    async verify() {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = { resident_id };

        const response = await api.get(
          "/rest-home/resident/pending-verification/check",
          {
            params,
          }
        );

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleItem(date) {
      this.$emit("pendingVerification", {
        tab: "check",
        nav: "check",
        date,
      });
    },
  },
};
</script>
